import * as React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import Typography from '@mui/material/Typography';
import { CiShoppingTag, CiBoxList, CiMoneyCheck1, CiMobile4, CiCircleCheck, CiViewList, CiViewTable, CiPen } from "react-icons/ci";
import moment from "moment";

export function TimelineCore({ timelineData }) {

  const formatHour = (isoDate) => {
    const formattedDate = moment(isoDate).add(5, 'hours').format('hh:mm A');
    return formattedDate;
  }

  return (
    <Timeline position="alternate">

      {
        timelineData.map((timeline, index) => {
          return (
            <TimelineItem key={index}>

              <TimelineOppositeContent
                key={index}
                sx={{ m: 'auto 0' }}
                align={timeline?.styles?.TimelineOppositeContent?.align}
                variant={timeline?.styles?.TimelineOppositeContent?.variant}
                color={timeline?.styles?.TimelineOppositeContent?.color ?? 'text.secondary'}
                style={{ fontFamily: 'GT Walsheim Pro', fontWeight: 'lighter' }}
              >
                {formatHour(timeline.createdAt)}
              </TimelineOppositeContent>

              <TimelineSeparator key={index}>
                <TimelineConnector key={index} />
                <TimelineDot
                  key={index}
                  color={'primary'}>
                  {
                    timeline?.styles?.icon?.name === 'CiCircleCheck' ? <CiCircleCheck size={timeline?.styles?.icon?.size} />
                      :
                      timeline?.styles?.icon?.name === 'CiShoppingTag' ? <CiShoppingTag size={timeline?.styles?.icon?.size} />
                        :
                        timeline?.styles?.icon?.name === 'CiBoxList' ? <CiBoxList size={timeline?.styles?.icon?.size} />
                          :
                          timeline?.styles?.icon?.name === 'CiMoneyCheck1' ? <CiMoneyCheck1 size={timeline?.styles?.icon?.size} />
                            :
                            timeline?.styles?.icon?.name === 'CiMobile4' ? <CiMobile4 size={timeline?.styles?.icon?.size} />
                              :
                              timeline?.styles?.icon?.name === 'CiViewList' ? <CiViewList size={timeline?.styles?.icon?.size} />
                                :
                                timeline?.styles?.icon?.name === 'CiViewTable' ? <CiViewTable size={timeline?.styles?.icon?.size} />
                                  :
                                  timeline?.styles?.icon?.name === 'CiPen' ? <CiPen size={timeline?.styles?.icon?.size} />
                                    :
                                    <></>
                  }

                </TimelineDot>

                <TimelineConnector />
              </TimelineSeparator>

              <TimelineContent key={index} sx={{ py: '12px', px: 2 }}>
                <Typography key={index} variant={timeline?.styles?.TimelineContent?.Typography?.variant} component={timeline?.styles?.TimelineContent?.Typography?.component} style={{ fontFamily: 'GT Walsheim Pro' }}>
                  {timeline?.name}
                </Typography>
                <Typography style={{ fontFamily: 'GT Walsheim Pro', fontWeight: 'lighter' }}>{timeline?.description}</Typography>
              </TimelineContent>

            </TimelineItem>
          )

        })
      }
    </Timeline>
  );
}
